import Image from 'next/image';
import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import { BiMobile, BiPalette, BiPlug, BiBell, BiWifiOff, BiSearch, BiUser, BiRocket, BiMessage, BiSupport, BiWrench } from 'react-icons/bi';
import FadeInAnimation from '../Common/FadeInAnimation';

const AppDevelopmentAppEntwicklungText = () => {
    const { t } = useTranslations();

    const features = [
        { icon: BiMobile, text: t('appDevelopment_appDevelopmentText_features_crossPlatform'), number: '01' },
        { icon: BiPalette, text: t('appDevelopment_appDevelopmentText_features_design'), number: '02' },
        { icon: BiPlug, text: t('appDevelopment_appDevelopmentText_features_integration'), number: '03' },
        { icon: BiBell, text: t('appDevelopment_appDevelopmentText_features_notifications'), number: '04' },
        { icon: BiWifiOff, text: t('appDevelopment_appDevelopmentText_features_offline'), number: '05' },
        { icon: BiSearch, text: t('appDevelopment_appDevelopmentText_features_aso'), number: '06' }
    ];

    const advantages = [
        { icon: BiUser, text: t('appDevelopment_appDevelopmentText_advantages_experience') },
        { icon: BiRocket, text: t('appDevelopment_appDevelopmentText_advantages_technology') },
        { icon: BiMessage, text: t('appDevelopment_appDevelopmentText_advantages_communication') },
        { icon: BiSupport, text: t('appDevelopment_appDevelopmentText_advantages_support') },
        { icon: BiWrench, text: t('appDevelopment_appDevelopmentText_advantages_maintenance') }
    ];

    return (
        <section className="about-area ptb-100 appdev-text">
            <div className="container">
                {/* Header Section */}
                <div className="row mb-5">
                    <div className="col-12 text-center">
                        <FadeInAnimation direction="up" delay={50}>
                            <span className="appdev-text__badge">
                                {t('appDevelopment_appDevelopmentText_subtitle')}
                            </span>
                            <h2 className="appdev-text__title">
                                {t('appDevelopment_appDevelopmentText_title')}
                            </h2>
                            <p className="appdev-text__description">
                                {t('appDevelopment_appDevelopmentText_description1')}
                            </p>
                        </FadeInAnimation>
                    </div>
                </div>

                {/* Features Grid */}
                <div className="row mb-5">
                    <div className="col-12 mb-4">
                        <FadeInAnimation direction="up" delay={100}>
                            <h3 className="appdev-text__section-title">
                                {t('appDevelopment_appDevelopmentText_includes')}
                            </h3>
                        </FadeInAnimation>
                    </div>
                    {features.map((feature, index) => {
                        const Icon = feature.icon;
                        return (
                            <div key={index} className="col-lg-4 col-md-6 mb-4">
                                <FadeInAnimation direction="up" delay={150 + (index * 50)}>
                                    <div className="appdev-feature-card">
                                        <div className="appdev-feature-card__number">
                                            {feature.number}
                                        </div>
                                        <div className="appdev-feature-card__icon-wrapper">
                                            <Icon className="appdev-feature-card__icon" />
                                        </div>
                                        <p className="appdev-feature-card__text">
                                            {feature.text}
                                        </p>
                                    </div>
                                </FadeInAnimation>
                            </div>
                        );
                    })}
                </div>

                {/* Description */}
                <div className="row mb-5">
                    <div className="col-12">
                        <FadeInAnimation direction="up" delay={500}>
                            <div className="appdev-highlight-box">
                                <p className="appdev-highlight-box__text">
                                    {t('appDevelopment_appDevelopmentText_description2')}
                                </p>
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>

                {/* Advantages Section */}
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12 mb-4">
                        <FadeInAnimation direction="right" delay={550}>
                            <div className="appdev-benefits-card">
                                <h3 className="appdev-benefits-card__title">
                                    {t('appDevelopment_appDevelopmentText_benefits')}
                                </h3>
                                {advantages.map((advantage, index) => {
                                    const Icon = advantage.icon;
                                    return (
                                        <div key={index} className="appdev-benefit-item">
                                            <div className="appdev-benefit-item__icon-wrapper">
                                                <Icon className="appdev-benefit-item__icon" />
                                            </div>
                                            <p className="appdev-benefit-item__text">
                                                {advantage.text}
                                            </p>
                                        </div>
                                    );
                                })}
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <FadeInAnimation direction="left" delay={600}>
                            <div className="appdev-image-card">
                                <Image
                                    src="/images/services/advantages.webp"
                                    alt="simplify data - App Entwicklung mit Simplify Data"
                                    width={400}
                                    height={100}
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AppDevelopmentAppEntwicklungText;
